import { gql } from '@apollo/client';

export const OPERATION_NAME = 'AuditLogTotalCount';

export const AUDIT_LOG_TOTAL_COUNT_QUERY = gql`
  query ${OPERATION_NAME}($where: org_audit_logs_bool_exp!) {
    org_audit_logs_aggregate(where: $where) {
      aggregate {
        totalCount: count
      }
    }
  }
`;

export function buildVariables({ where }) {
  return { where };
}
